<script lang="ts">
	import { browser } from '$app/environment';
	import ScrollToTopButton from './ScrollToTopButton.svelte';
	import IChat from '../i_chat/IChat.svelte';
</script>

{#if browser}
	<div class="fixed right-20 bottom-5 space-y-5 z-50">
		<ScrollToTopButton />
		<IChat />
	</div>
{/if}
